import { Link } from 'react-router-dom';
import type { Drama } from '@/types';
import { getActorById } from '@/lib/data';
import StarRating from '@/components/base/StarRating';

interface DramaCardProps {
  drama: Drama;
  rank?: number;
}

export default function DramaCard({ drama, rank }: DramaCardProps) {
  const castNames = drama.cast
    .map((id) => getActorById(id)?.name)
    .filter(Boolean)
    .slice(0, 2)
    .join(' / ');

  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group block cursor-pointer rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={drama.poster}
          alt={`${drama.title} 韩剧海报`}
          title={`${drama.title} - 韩剧电视剧`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-x-0 top-0 p-2.5 flex items-start justify-between">
          <span
            className={`text-xs font-medium px-2 py-0.5 rounded-full text-white ${
              drama.status === '更新中' ? 'bg-accent-500' : 'bg-secondary-700'
            }`}
          >
            {drama.status}
          </span>
          {rank !== undefined && (
            <span className="w-7 h-7 rounded-full bg-primary-500 text-white text-sm font-bold flex items-center justify-center">
              {rank}
            </span>
          )}
        </div>
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/75 to-transparent"></div>
        <div className="absolute bottom-2 left-2.5 right-2.5 flex items-center justify-between">
          <StarRating rating={drama.rating} />
          <span className="text-xs text-white/85 flex items-center gap-1">
            <i className="ri-fire-line text-accent-400"></i>
            {(drama.heat / 1000).toFixed(1)}k
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {drama.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {drama.year} · 全 {drama.episodes} 集 · {drama.genres.slice(0, 2).join(' · ')}
        </p>
        <p className="mt-1.5 text-xs text-foreground-600 truncate">
          <i className="ri-user-star-line mr-1 text-foreground-400"></i>
          {castNames}
        </p>
      </div>
    </Link>
  );
}